import { api } from "@/lib/api"
import { hasLinearConnection } from "@/lib/linear-connection"
import { useZeroWorkspace } from "@/lib/zero"

export interface CustomerStatus {
	id: string | null
	name: string
	color: string
}

const PROSPECT_FALLBACK: CustomerStatus = {
	id: null,
	name: "Prospect",
	color: "#f59e0b",
}

// Mirrors resolveNewCustomerStatusId on the server: a new Linear customer
// starts as the workspace's Prospect status.
export function pickDefaultCustomerStatus(
	statuses: readonly { id: string; name: string; color: string }[],
): CustomerStatus {
	return (
		statuses.find(
			(status) => status.name.trim().toLowerCase() === "prospect",
		) ?? PROSPECT_FALLBACK
	)
}

export function useDefaultCustomerStatus(): CustomerStatus {
	const workspace = useZeroWorkspace()
	const customerStatusesQuery = api.linear.customerStatuses.useQuery(
		undefined,
		{
			enabled: hasLinearConnection(workspace),
			cacheTime: Infinity,
			staleTime: Infinity,
		},
	)
	return pickDefaultCustomerStatus(
		customerStatusesQuery.data?.customerStatuses.nodes ?? [],
	)
}
